import { api } from './api';
import { PaginatedList, PaginatedRequest } from '../types';

export const getGlobalVariableList = (params: PaginatedRequest) =>
  api.request<GlobalVariableListType>({
    method: 'GET',
    url: '/global_variables/',
    params,
  });

/**
 * Refused with a 400 on `name` when a variable with the same name already
 * exists. Names are compared ignoring case, spaces and punctuation -- forms
 * look a variable up the same way.
 */
export const createGlobalVariable = (data: GlobalVariableType) =>
  api.request<GlobalVariableType>({
    method: 'POST',
    url: '/global_variables/',
    data,
  });

export const updateGlobalVariable = (data: GlobalVariableType) =>
  api.request<GlobalVariableType>({
    method: 'PATCH',
    url: `/global_variables/${data.id}/`,
    data,
  });

/** Soft delete. Forms mapped to it print nothing there from then on. */
export const deleteGlobalVariable = (id: number) =>
  api.request<void>({
    method: 'DELETE',
    url: `/global_variables/${id}/`,
  });

type GlobalVariableListType = PaginatedList<GlobalVariableType>;

export interface GlobalVariableType {
  id?: number;
  name?: string;
  value?: string;
  updatedAt?: string;
}
